import { COLORS } from "./colors";

export function getResponsiveCSS() {
  return `
  @keyframes tooltipIn { from { opacity: 0; transform: translateX(-6px); } to { opacity: 1; transform: translateX(0); } }
  @keyframes dropPulse { 0%, 100% { opacity: 0.03; } 50% { opacity: 0.08; } }
  @keyframes nodeAppear { from { opacity: 0; transform: scale(0.8); } to { opacity: 1; transform: scale(1); } }
  @keyframes hubGlow {
    0%, 100% { box-shadow: 0 0 20px rgba(79,70,229,0.25), 0 0 60px rgba(79,70,229,0.08); }
    50% { box-shadow: 0 0 28px rgba(79,70,229,0.4), 0 0 80px rgba(79,70,229,0.15); }
  }
  @keyframes agentPulse {
    0%, 100% { box-shadow: 0 0 16px rgba(168,85,247,0.15), inset 0 0 12px rgba(168,85,247,0.05); }
    50% { box-shadow: 0 0 24px rgba(168,85,247,0.25), inset 0 0 16px rgba(168,85,247,0.1); }
  }
  @keyframes slideUp { from { opacity: 0; transform: translateY(100%); } to { opacity: 1; transform: translateY(0); } }
  @keyframes slideInRight { from { opacity: 0; transform: translateX(100%); } to { opacity: 1; transform: translateX(0); } }
  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }
  @keyframes spin { to { transform: rotate(360deg); } }
  * { box-sizing: border-box; }

  /* WCAG 2.1 SC 2.3.3 — honor OS-level prefers-reduced-motion.
     Disables all CSS keyframe animations and CSS transitions globally;
     pairs with the <MotionConfig reducedMotion="user"> in App.jsx
     which catches Framer Motion's spring-physics paths. */
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }

  /* Custom scrollbar for the canvas */
  .canvas-scroll::-webkit-scrollbar { width: 10px; height: 10px; }
  .canvas-scroll::-webkit-scrollbar-track {
    background: ${COLORS.bg}; border-radius: 0;
    border-left: 1px solid ${COLORS.border};
    border-top: 1px solid ${COLORS.border};
  }
  .canvas-scroll::-webkit-scrollbar-thumb {
    background: ${COLORS.border}; border-radius: 5px;
    border: 2px solid ${COLORS.bg};
    transition: background 0.2s;
  }
  .canvas-scroll::-webkit-scrollbar-thumb:hover { background: ${COLORS.textDim}; }
  .canvas-scroll::-webkit-scrollbar-thumb:active { background: ${COLORS.accent}; }
  .canvas-scroll::-webkit-scrollbar-corner { background: ${COLORS.bg}; }
  .canvas-scroll { scrollbar-width: thin; scrollbar-color: ${COLORS.border} ${COLORS.bg}; }

  /* Styled scrollbars for all panels */
  .panel-scroll::-webkit-scrollbar { width: 6px; height: 6px; }
  .panel-scroll::-webkit-scrollbar-track { background: transparent; }
  .panel-scroll::-webkit-scrollbar-thumb {
    background: ${COLORS.border}; border-radius: 3px;
  }
  .panel-scroll::-webkit-scrollbar-thumb:hover { background: ${COLORS.textDim}; }
  .panel-scroll { scrollbar-width: thin; scrollbar-color: ${COLORS.border} transparent; }

  /* Horizontal scroll for tables */
  .table-scroll::-webkit-scrollbar { height: 8px; }
  .table-scroll::-webkit-scrollbar-track {
    background: ${COLORS.bg}; border-radius: 4px;
    margin: 0 8px;
  }
  .table-scroll::-webkit-scrollbar-thumb {
    background: ${COLORS.border}; border-radius: 4px;
    border: 1px solid ${COLORS.bg};
  }
  .table-scroll::-webkit-scrollbar-thumb:hover { background: ${COLORS.textDim}; }
  .table-scroll { scrollbar-width: thin; scrollbar-color: ${COLORS.border} ${COLORS.bg}; }

  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none; appearance: none;
    width: 18px; height: 18px; border-radius: 50%;
    background: ${COLORS.accent}; border: 3px solid ${COLORS.surface};
    box-shadow: 0 0 10px ${COLORS.accentGlow}, 0 2px 6px rgba(0,0,0,0.4);
    cursor: pointer; position: relative; z-index: 3;
  }
  input[type="range"]::-moz-range-thumb {
    width: 18px; height: 18px; border-radius: 50%;
    background: ${COLORS.accent}; border: 3px solid ${COLORS.surface};
    box-shadow: 0 0 10px ${COLORS.accentGlow}, 0 2px 6px rgba(0,0,0,0.4); cursor: pointer;
  }
  input[type="range"]::-webkit-slider-runnable-track { background: transparent; height: 6px; }
  input[type="range"]::-moz-range-track { background: transparent; height: 6px; }
  @media (max-width: 639px) {
    .desktop-only { display: none !important; }
    .mobile-scroll { overflow-x: auto; -webkit-overflow-scrolling: touch; }
  }
  @media (min-width: 640px) {
    .mobile-only { display: none !important; }
  }
  @media (min-width: 640px) and (max-width: 1023px) {
    .desktop-wide { display: none !important; }
  }
`;
}

// Backwards-compat: existing imports of RESPONSIVE_CSS still work (initial dark theme snapshot)
export const RESPONSIVE_CSS = getResponsiveCSS();
